import type { KnowledgeEntry, KnowledgeKind } from '@/features/editor/types/knowledge.types'

export function kindLabel(kind: KnowledgeKind) {
  return kind === 'worldInfo' ? '世界信息' : '角色档案'
}

export function safeTitle(e: KnowledgeEntry) {
  const t = (e.title ?? '').trim()
  return t.length ? t : '未命名条目'
}

export function uniqueKeywords(input: string[]) {
  const cleaned = input.map((s) => s.trim()).filter(Boolean)
  return Array.from(new Set(cleaned))
}

